import React from 'react';

import {NavLink} from 'react-router-dom';
import classNames from 'classnames';
import {SpanIcon} from '@mazraeapp/react_icon_kit';

interface NavLinkItemProps {
  label: string;
  icon: string;
  activeIcon: string;
  route: string;
  onClick?: () => void;
}
const NavLinkItem = ({
  label,
  icon,
  activeIcon,
  route,
  onClick,
}: NavLinkItemProps) => {
  return (
    <NavLink
      className={({isActive}) =>
        classNames(
          'flex flex-col justify-center items-center no-underline gap-2 w-100',
          {
            'text-farm-shop-500 focus:text-farm-shop-500 hover:text-farm-shop-500':
              isActive,
            'text-gray-800 focus:text-gray-800 hover:text-gray-800': !isActive,
          },
        )
      }
      onClick={onClick}
      to={route}
    >
      {({isActive}) => (
        <>
          <SpanIcon
            className={classNames(
              'text-[24px]',
              !isActive ? icon : activeIcon,
              {
                'text-farm-shop-500 focus:text-farm-shop-500 hover:text-farm-shop-500':
                  isActive,
                'text-gray-800 focus:text-gray-800 hover:text-gray-800':
                  !isActive,
              },
            )}
          />
          <span
            className={classNames('text-xs font-Medium', {
              'text-farm-shop-500 focus:text-farm-shop-500 hover:text-farm-shop-500':
                isActive,
              'text-gray-800 focus:text-gray-800 hover:text-gray-800':
                !isActive,
            })}
          >
            {label}
          </span>
        </>
      )}
    </NavLink>
  );
};

export default NavLinkItem;
